"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
const CheckCircleOutline_1 = __importDefault(require("@mui/icons-material/CheckCircleOutline"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const mui_1 = require("tss-react/mui");
const taskHeight = 42;
const useStyles = (0, mui_1.makeStyles)()((theme) => ({
    container: {
        width: 194,
        height: taskHeight,
        display: 'flex',
        marginLeft: 20,
        marginRight: 20,
        marginTop: 'auto',
        marginBottom: 'auto',
        verticalAlign: 'middle',
        flex: 1,
    },
    taskFrame: {
        width: 155,
        height: taskHeight,
        borderRadius: 20,
        borderColor: theme.palette.border.dark,
        borderWidth: 1,
        borderStyle: 'solid',
        flex: 1,
        '&.selected': {
            background: theme.palette.action.selected,
        },
    },
    iconHolder: {
        flex: 0,
        minWidth: 24,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    checkIcon: {
        width: 24,
        height: 24,
        color: theme.palette.border.dark,
        '&.completed': {
            color: theme.palette.success.dark,
        },
    },
    connector: {
        flex: 0,
        minWidth: 20,
        height: 1,
        background: theme.palette.border.dark,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    btnText: {
        lineHeight: `${taskHeight - 3}px`,
        fontSize: '16px',
        fontWeight: 500,
        color: theme.palette.primary.main,
        '&.completed': {
            color: theme.palette.text.secondary,
        },
    },
}));
const TaskWidget = ({ onClick, completed, selected, title, name }) => {
    const { classes } = useStyles();
    const CheckIcon = completed ? CheckCircle_1.default : CheckCircleOutline_1.default;
    const colorClass = (completed ? ' completed ' : '') + (selected ? ' selected' : '');
    return (<div className={classes.container}>
      <div className={classes.iconHolder}>
        <CheckIcon className={(0, classnames_1.default)(classes.checkIcon, colorClass)}/>
      </div>
      <div className={classes.connector}/>
      <ButtonBase_1.default onClick={(e) => onClick(e, name)}>
        <div className={(0, classnames_1.default)(classes.taskFrame, colorClass)}>
          <Typography_1.default className={(0, classnames_1.default)(classes.btnText, colorClass)}>
            {title}
          </Typography_1.default>
        </div>
      </ButtonBase_1.default>
    </div>);
};
exports.default = TaskWidget;
